import { useCallback } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { setCarInstance, updateErrors } from 'store/carInstance/actions';
import { selectErrors, selectValues } from 'store/carInstance/selectors';

import { useDisabledFields } from '../../hooks/useDisabledFields';

import { NAME } from './EngineVolumeInput.constants';

export const useEngineVolumeInputPresenter = () => {
  const dispatch = useDispatch();

  const { [NAME]: error } = useSelector(selectErrors);
  const { [NAME]: storedValue } = useSelector(selectValues);

  const value = storedValue ? String(Number(storedValue) / 1000) : '';

  const { disabled: pageRestrict } = useDisabledFields();

  const onChange = useCallback(
    ({ [NAME]: value }) => {
      const result = value ? String(Number(value) * 1000) : undefined;

      dispatch(setCarInstance({ [NAME]: result }));
      dispatch(updateErrors({ [NAME]: '' }));
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return {
    disabled: pageRestrict,
    error,
    onChange,
    value,
  };
};
